import styled from 'styled-components';
import toRem from 'utils/toRem';
import Container from './shared/container';
import ScheduleItem from './schedule_item';

const ScheduleTable = ({
  fields: {
    title,
    scheduleItems,
    alignment,
    backgroundColor = 'grey',
    fullWidth = false,
  },
  ...rest
}) => (
  <Container
    backgroundColor={backgroundColor}
    isFullWidth={fullWidth}
    className="schedule-table"
    hasReducedPadding
    style={{ textAlign: alignment }}
    {...rest}>
    {title && <Title className="h3">{title}</Title>}

    {scheduleItems.length > 0 && (
      <ItemList className="schedule-table__items">
        {scheduleItems.map(({ sys: { id }, fields }) => (
          <ScheduleItem
            {...fields}
            hasGreyBackground={backgroundColor === 'white'}
            key={id}
          />
        ))}
      </ItemList>
    )}
  </Container>
);

const Title = styled.h2`
  font-size: ${toRem(30)};
  line-height: ${toRem(36)};
  margin-block: 0 ${toRem(32)};
`;

const ItemList = styled.div`
  display: grid;
  gap: ${toRem(16)};
`;

export default ScheduleTable;
